const PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY;

(function () {
  emailjs.init({
    publicKey: PUBLIC_KEY,
  });
})();
